import {
  ActionIcon,
  Badge,
  Box,
  Button,
  ComboboxItem,
  Flex,
  Grid,
  GridCol,
  Input,
  Menu,
  rem,
  Select,
  Text,
  Title,
  Tooltip,
} from "@mantine/core";
import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import {
  useDebouncedCallback,
  useHotkeys,
  useIsFirstRender,
  useMediaQuery,
} from "@mantine/hooks";
import { modals } from "@mantine/modals";
import {
  IconBarcode,
  IconBrandBootstrap,
  IconCaretDown,
  IconClipboardList,
  IconEdit,
  IconEye,
  IconFileExport,
  IconFileTypography,
  IconFileUpload,
  IconPlus,
  IconSearch,
  IconStatusChange,
  IconTimeDuration15,
  IconTrash,
  IconUserCode,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  MRT_SortingState,
  useMantineReactTable,
} from "mantine-react-table";
import moment from "moment";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router";
import { toast } from "react-toastify";
import * as xlsx from "xlsx";
import {
  keySearchWarehouseOutWardList,
  repositoryPos,
  styleTableMantine,
} from "../../../_base/_const/_constVar";
import _breadcrumb from "../../../_base/component/_layout/_breadcrumb";
import { formatDateTransfer } from "../../../common/FormatDate/FormatDate";
import { _localization } from "../../../config/location";
import { cobalt_blue, green, teal } from "../../../const/variables";
import {
  getInventorySelectPos,
  getMasterOrgSelect,
  getTblDmEmployeeSelect,
  getTblInventoryTransactionTypeOutWard,
} from "../../../service/getSelectApi";
import DeleteView from "./components/DeleteModal";
import { dataStatusOption } from "./constants";
import useDynamicHeight from "./hooks/useDynamicHeight";
import { outward } from "./services";
import { TblWarehouseOutwardGetList } from "./types/TblWarehouseOutward";
function getColorStatus(text: any) {
  switch (text) {
    case "OPEN":
      return cobalt_blue.base;
    case "LOCK":
      return green.light;
    case "CANCLE":
      return "red";
    default:
      return cobalt_blue.base;
  }
}

function getStatus(text: any) {
  switch (text) {
    case "OPEN":
      return "Lưu tạm";
    case "LOCK":
      return "Đã xuất";
    case "CANCLE":
      return "Hủy";
    default:
      return "Tạo mới";
  }
}

const WarehouseOutWard = () => {
  const navigate = useNavigate();
  const sizeGrid = { base: 6, sm: 4, md: 3, lg: 3, xl: 2 };
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<TblWarehouseOutwardGetList[]>([]);
  const [dataInv, setDataInv] = useState<ComboboxItem[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [dataInventoryTransactionType, setDataInventoryTransactionType] =
    useState<ComboboxItem[]>([]);
  const [dataEmployee, setDataEmployee] = useState<ComboboxItem[]>([]);
  const [dataBranch, setDataBranch] = useState<ComboboxItem[]>([]);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [sorting, setSorting] = useState<MRT_SortingState>([]);
  const height = useDynamicHeight(headerRef, 150);
  //count
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const isSmallScreen = useMediaQuery("(max-width: 768px)");
  const [columnPinning, setColumnPinning] = useState<boolean | undefined>(true);
  const firstRender = useIsFirstRender();
  const _searchJson = localStorage.getItem(keySearchWarehouseOutWardList)
    ? JSON.parse(localStorage.getItem(keySearchWarehouseOutWardList) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") === "true";
  const [dataItemCode, setDataItemCode] = useState<any[]>([]);
  const lastSearchRef = useRef(""); //dùng để lưu từ khóa tìm kiếm tránh call lặp lại
  const innitStateSearch = useMemo(
    () => ({
      KeySearch:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.KeySearch as string)
          : "",
      FromTransationDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.FromTransationDate
          ? new Date(_searchJson.FromTransationDate)
          : new Date(
              new Date(
                new Date(
                  new Date().setDate(new Date().getDate() - 14),
                ).setHours(0, 0, 0, 0),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      ToTransationDate:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.ToTransationDate
          ? new Date(_searchJson.ToTransationDate)
          : new Date(
              new Date(
                new Date(new Date().setDate(new Date().getDate() + 1)).setHours(
                  0,
                  0,
                  0,
                  0,
                ),
              ).getTime() +
                7 * 60 * 60 * 1000,
            ),
      SourceTypeCode:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.SourceTypeCode as string)
          : "",
      InvId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.InvId as string)
          : "",
      Status:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.Status as string)
          : "",
      EmpId:
        firstRender && _searchJson && checkedPinSearch
          ? (_searchJson.EmpId as string)
          : "",
      IsEcommerce:
        firstRender &&
        _searchJson &&
        checkedPinSearch &&
        _searchJson.IsEcommerce != null
          ? String(_searchJson.IsEcommerce)
          : null,
      ItemCode:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.ItemCode
          : "",
      BranchId:
        firstRender && _searchJson && checkedPinSearch
          ? _searchJson.BranchId
          : String(
              JSON.parse(localStorage.getItem("userLoginHeader") || "{}")
                ?.branchId || "",
            ),
    }),
    [firstRender, _searchJson],
  );

  const form = useForm({
    mode: "uncontrolled",
    initialValues: innitStateSearch,
  });

  // Giữ lại option mã sản phẩm đang lọc để hiển thị đúng trên ô chọn,
  // kể cả khi giá trị được lấy lại từ localStorage (chưa có trong dataItemCode)
  const [selectedItemCode, setSelectedItemCode] = useState<ComboboxItem | null>(
    innitStateSearch.ItemCode
      ? {
          value: String(innitStateSearch.ItemCode),
          label: String(innitStateSearch.ItemCode),
        }
      : null,
  );

  const dataItemCodeSelect = useMemo(() => {
    if (
      selectedItemCode &&
      !dataItemCode.some((item) => item?.value === selectedItemCode.value)
    ) {
      return [selectedItemCode, ...dataItemCode];
    }
    return dataItemCode;
  }, [dataItemCode, selectedItemCode]);

  const columns = React.useMemo<MRT_ColumnDef<TblWarehouseOutwardGetList>[]>(
    () => [
      {
        accessorKey: "transactionCode",
        header: "Mã phiếu",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              radius="sm"
              variant="dot"
              size="md"
              style={{ cursor: "pointer" }}
              color={renderedCellValue === null ? "red" : green.base}
              onDoubleClick={() =>
                detailData(
                  row.original.transactionId,
                  row.original.sourceType,
                  true,
                )
              }
            >
              {renderedCellValue === null ? null : renderedCellValue}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "status",
        header: "Trạng thái",
        size: 130,
        Cell: ({ row }) => (
          <>
            <Badge color={getColorStatus(row.original.status)}>
              {getStatus(row.original.status)}
            </Badge>
          </>
        ),
      },
      {
        accessorKey: "transactionDate",
        header: "Ngày giao dịch",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createDate",
        header: "Ngày lập",
        size: 150,
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue && formatDateTransfer(renderedCellValue)}</>
        ),
      },
      {
        accessorKey: "createName",
        header: "Người lập",
        size: 200,
        // Cell: ({ row }) => (
        //   <>
        //     <AvatarUtils value={row.original.createName ?? ""} />
        //   </>
        // ),
      },

      {
        accessorKey: "sourceCode",
        header: "Mã chứng từ gốc",
        Cell: ({ renderedCellValue }: any) => (
          <Text fw={700} size="sm">
            {renderedCellValue}
          </Text>
        ),
      },
      {
        accessorKey: "sourceTypeName",
        header: "Loại chứng từ gốc",
        Cell: ({ renderedCellValue, row }) => (
          <>
            <Badge color={getColorType(row.original.sourceType)}>
              {renderedCellValue}
            </Badge>
          </>
        ),
        size: 255,
      },
      {
        accessorKey: "branchName",
        header: "Chi nhánh",
        Cell: ({ renderedCellValue, row }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "invName",
        header: "Kho",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "shippingStatus",
        header: "Trạng thái GV",
        Cell: ({ renderedCellValue }) => (
          <Badge size="sm" color="cyan">
            {renderedCellValue ? renderedCellValue : "KHONG_YEU_CAU"}
          </Badge>
        ),
      },
      {
        accessorKey: "shippingVendor",
        header: "Bộ phận GV",
      },
      {
        accessorKey: "tenNVGV",
        header: "Nhân viên GV",
      },
      {
        accessorKey: "sdtNVGV",
        header: "SĐT GV",
      },
      {
        accessorKey: "attribute46",
        header: "Thời gian GV tiếp nhận đơn",
        size: 250,
      },
      {
        accessorKey: "attribute45",
        header: "Thời gian GV hoàn thành đơn",
        size: 250,
      },
      {
        accessorKey: "description",
        header: "Ghi chú",
        Cell: ({ renderedCellValue, row }) => (
          <Tooltip label={renderedCellValue}>
            <p>{renderedCellValue}</p>
          </Tooltip>
        ),
      },
      {
        accessorKey: "atribute2",
        header: "Id đơn TMĐT",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
      },
      {
        accessorKey: "action",
        header: "Thao tác",
        size: 130,
        enableSorting: false,
        enableColumnActions: false,
        enableColumnFilter: false,
        Cell: ({ renderedCellValue, row, table }) => (
          <Box
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
            }}
          >
            <Tooltip label="Chỉnh sửa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="orange"
                disabled={row.original.status === "LOCK"}
                onClick={async () => {
                  editData(
                    row.original.transactionId,
                    row.original.sourceType,
                    false, // status !== "LOCK"
                  );
                }}
              >
                <IconEdit size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xem chi tiết">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="blue"
                onClick={async () => {
                  detailData(
                    row.original.transactionId,
                    row.original.sourceType,
                    true, // status === "LOCK"
                  );
                }}
              >
                <IconEye size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
            <Tooltip label="Xóa">
              <ActionIcon
                variant="light"
                aria-label="Settings"
                color="red"
                disabled={row.original.status === "LOCK"}
                onClick={async () => {
                  deleteData(
                    row.original.transactionId,
                    row.original.sourceType ?? "",
                  );
                }}
              >
                <IconTrash size={20} stroke={1.5} />
              </ActionIcon>
            </Tooltip>
          </Box>
        ),
      },
    ],
    [dataInventoryTransactionType, dataInv],
  );

  const getColorType = (type: string | null) => {
    switch (type) {
      case "XUAT_DIEU_CHUYEN_CHI_NHANH":
        return "#f06418";
      case "XUAT_DIEU_CHUYEN_CHI_NHANH_SERIAL":
        return "#ffab09";
      case "XUAT_HUY":
        return "#d9d02f";
      case "XUAT_DIEU_CHINH":
        return "#6bd731";
      case "XUAT_DIEU_CHUYEN_NOI_BO":
        return "#09b8ff";
      case "XUAT_DIEU_CHUYEN_NOI_BO_SERIAL":
        return "#1f32c4";
      case "XUAT_TRA_NCC":
        return "#2bdd66";
      case "XUAT_BAN":
        return teal.light;
      case null:
        return "rgba(0, 0, 0, 0)";
      case "NOI_BO":
        return "#656a7e";
    }
  };

  const handleExport = () => {
    try {
      const worksheet = xlsx.utils.json_to_sheet(data);
      const workbook = xlsx.utils.book_new();
      xlsx.utils.book_append_sheet(workbook, worksheet, "Data");
      xlsx.writeFile(workbook, "danh-sach-phieu-xuat-kho.xlsx");
      toast.success("Export excel thành công", { autoClose: 1500 });
    } catch (error) {
      toast.error("Export excel thất bại", { autoClose: 1500 });
    }
  };

  const createData = () => {
    navigate("/warehouse-config/create-warehouse-out-ward");
  };

  const editData = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    navigate("/warehouse-config/edit-warehouse-out-ward", {
      state: { id: id, type: type, isLocked: isLocked },
    });
  };

  const detailData = (
    id: string | number,
    type: string | number | null,
    isLocked: boolean,
  ) => {
    console.log(id, type, isLocked);
    navigate("/warehouse-config/detail-warehouse-out-ward", {
      state: { id: id, type: type, isLocked: isLocked },
    });
  };

  const deleteData = (id: string | number, sourceType: string) => {
    try {
      modals.openConfirmModal({
        title: (
          <>
            <Title order={5}>Xóa phiếu xuất kho!</Title>
          </>
        ),

        size: "550px",
        children: (
          <DeleteView
            idItem={id}
            onClose={setDeleteViewStatus}
            sourceType={sourceType}
          />
        ),
        confirmProps: { display: "none" },
        cancelProps: { display: "none" },
      });
    } catch (error) {
      console.error(error);
      return;
    }
  };

  useHotkeys([
    [
      "F11",
      () => {
        createData();
      },
    ],
  ]);

  const fetchData = async () => {
    setIsLoading(true);
    // setIsRefetching(true);
    // setIsError(false);

    let queryParams = {
      Skip:
        firstRender && _searchJson
          ? _searchJson.Skip
          : pagination.pageIndex * pagination.pageSize,
      Take: firstRender && _searchJson ? _searchJson.Take : pagination.pageSize,
    } as any;

    try {
      const search = form.getValues();
      const isEcommerceSelected = String(search?.IsEcommerce) === "true";

      queryParams = {
        ...queryParams,
        KeySearch: search?.KeySearch ? search?.KeySearch.trim().toString() : "",
        InvId: search?.InvId ? search?.InvId.toString() : "",
        FromTransationDate: search?.FromTransationDate
          ? moment(search?.FromTransationDate).format(
              "YYYY-MM-DDT00:00:00.000[Z]",
            )
          : "",
        ToTransationDate: search?.ToTransationDate
          ? moment(search?.ToTransationDate).format(
              "YYYY-MM-DDT00:00:00.000[Z]",
            )
          : "",
        SourceTypeCode: search?.SourceTypeCode
          ? search?.SourceTypeCode.toString()
          : "",
        Status: search?.Status ? search?.Status.toString() : "",
        EmpId: search?.EmpId ? search?.EmpId.toString() : "",
        Type: 2,
        ItemCode: search?.ItemCode || "",
        BranchId: search?.BranchId || "",
      };
      // chỉ thêm IsEcommerce khi chọn true
      if (isEcommerceSelected) {
        queryParams.IsEcommerce = true;
      }
      const urlParams = new URLSearchParams(queryParams as any);
      if (sorting?.length > 0) {
        const { id, desc } = sorting[0];
        urlParams.append("sort", id);
        urlParams.append("isOrder", String(desc));
      }

      const response = await outward.getListOutward(queryParams);
      if (response && response.success) {
        let result = response.data;
        setIsLoading(false);
        setData(result || []);
        setRowCount(response.totalCount);
        table.resetRowSelection();
      } else setData([]);
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      localStorage.setItem(
        keySearchWarehouseOutWardList,
        JSON.stringify(queryParams),
      );
    }
  };

  const fetchdataInventoryTransactionType = async () => {
    const response = await getTblInventoryTransactionTypeOutWard();

    setDataInventoryTransactionType(
      response.map((type) => ({ value: type.value, label: type.text })),
    );
  };

  const fetchDataEmployee = async () => {
    const response = await getTblDmEmployeeSelect();
    setDataEmployee(
      response.map((employee) => ({
        value: employee.value,
        label: employee.text + " - " + employee.att1,
      })),
    );
  };

  const fetchDataInv = async () => {
    const getDataInv = await getInventorySelectPos();

    const mappedData = getDataInv
      .filter(
        (item) => item.code != null && item.name != null && item.id !== null,
      )
      .map((item) => ({
        value: item.id.toString(),
        label: `(${item.code}) ${item.name}`,
      }));
    setDataInv(mappedData);
  };

  const getDataBranchSelect = async () => {
    const res = await getMasterOrgSelect();
    setDataBranch(
      res
        ?.filter(
          (item) =>
            item.text != null && item.value != null && item.value !== "-1",
        )
        ?.map((item) => ({
          value: item.value?.toString(),
          label: `${item.att1} - ${item.text}`,
        })),
    );
  };

  // Lấy dữ liệu mã sản phẩm
  const DataItemCode = async (keySearch: string) => {
    try {
      let url = "";
      if (keySearch && keySearch.length > 0) {
        url += `&ItemCodes=${keySearch}`;
      }
      const response = await repositoryPos.get(
        `/api/v1/TblItem/get-select?Key=${keySearch}&Page=30`,
      );
      if (response && response.success) {
        const transformedData = response.data
          ?.filter((i: any) => i.value && i.text)
          .map((branch: any) => ({
            value: branch.value,
            label: branch.text,
          }));
        const uniqueData = Array.from(
          new Set(transformedData.map((item: any) => item.value)),
        ).map((value) =>
          transformedData.find((item: any) => item.value === value),
        );
        setDataItemCode(uniqueData);
      }
    } catch (error) {
      console.error(error);
      return;
    }
  };
  // Sử dụng debounce để trì hoãn việc gọi API
  const debouncedDataItemCode = useDebouncedCallback((value: string) => {
    const trimmedValue = value.trim();
    if (trimmedValue.length >= 3 && trimmedValue !== lastSearchRef.current) {
      lastSearchRef.current = trimmedValue; // Ghi nhớ từ khóa
      DataItemCode(trimmedValue); // Gọi API với từ khóa tìm kiếm
    }
  }, 500);

  useEffect(() => {
    if (isSmallScreen) {
      setColumnPinning(false); // Bỏ ghim cột khi thu nhỏ màn hình
    } else {
      setColumnPinning(true);
    }
  }, [isSmallScreen]);

  useEffect(() => {
    fetchData();
  }, [sorting, deleteViewStatus, pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: true,
    positionToolbarAlertBanner: "bottom",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    getRowId: (row) => row.transactionId?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["mrt-row-select", "transactionCode", "status"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: true,
    rowCount,
    onSortingChange: setSorting,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
      sorting,
    },
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "md",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: columnPinning,
    mantineTableProps: {
      striped: false,
    },
  });

  useEffect(() => {
    fetchDataInv();
    fetchDataEmployee();
    fetchdataInventoryTransactionType();
    getDataBranchSelect();
    // Lấy lại danh sách mã sản phẩm theo giá trị đang lọc để hiển thị đúng tên sản phẩm
    if (selectedItemCode?.value) {
      lastSearchRef.current = selectedItemCode.value;
      DataItemCode(selectedItemCode.value);
    }
  }, []);

  // Cập nhật lại label của mã sản phẩm đang lọc khi lấy được dữ liệu từ API
  useEffect(() => {
    if (!selectedItemCode) return;
    const option = dataItemCode.find(
      (item) => item?.value === selectedItemCode.value,
    );
    if (option && option.label !== selectedItemCode.label) {
      setSelectedItemCode(option);
    }
  }, [dataItemCode, selectedItemCode]);
  // Lưu key search
  return (
    <>
      <div
        style={{ border: "1px solid #dee2e6", padding: "10px" }}
        ref={headerRef}
      >
        <Flex
          gap={0}
          justify={"space-between"}
          align="center"
          direction="row"
          wrap="wrap"
          w={"100%"}
        >
          <_breadcrumb></_breadcrumb>
          <Flex gap="md" align="center" direction="row" wrap="wrap">
            <Button
              leftSection={<IconPlus size={14} />}
              color="blue"
              variant="outline"
              onClick={() => {
                createData();
              }}
            >
              Tạo mới (F11)
            </Button>

            <Menu shadow="md" width={200}>
              <Menu.Target>
                <Button
                  // size="xs"
                  rightSection={
                    <IconCaretDown
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                >
                  Chức năng
                </Button>
              </Menu.Target>

              <Menu.Dropdown>
                <Menu.Label>Application</Menu.Label>
                <Menu.Item
                  leftSection={
                    <IconFileExport
                      style={{ width: rem(14), height: rem(14) }}
                    />
                  }
                  onClick={handleExport}
                >
                  Export Excel
                </Menu.Item>
                <Tooltip label={"Chức năng đang update"}>
                  <Menu.Item
                    leftSection={
                      <IconFileUpload
                        style={{ width: rem(14), height: rem(14) }}
                      />
                    }
                  >
                    Import Excel
                  </Menu.Item>
                </Tooltip>
              </Menu.Dropdown>
            </Menu>
          </Flex>
        </Flex>
        <form>
          <Grid mt={"10px"}>
            <GridCol span={sizeGrid}>
              <Input
                w={"100%"}
                placeholder="Từ khoá"
                type="text"
                leftSection={<IconSearch color="#15aabf" />}
                key={form.key("KeySearch")}
                // onKeyDown={async (e) => {
                //   if (e.key === "Enter") {
                //     await fetchData();
                //     localStorage.setItem(
                //       "allValueKeySearch",
                //       JSON.stringify({
                //         ...form.getValues(),
                //         url: String(window.location.pathname),
                //       })
                //     );
                //   }
                // }}
                {...form.getInputProps("KeySearch")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <DatePickerInput
                type="default"
                key={form.key("FromTransationDate")}
                leftSection={<IconTimeDuration15 color="#15aabf" />}
                size="sm"
                placeholder="Từ ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                {...form.getInputProps("FromTransationDate")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <DatePickerInput
                type="default"
                key={form.key("ToTransationDate")}
                leftSection={<IconTimeDuration15 color="#15aabf" />}
                size="sm"
                placeholder="Đến ngày"
                locale="vi"
                valueFormat="DD/MM/YYYY"
                {...form.getInputProps("ToTransationDate")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <Select
                placeholder={"Trạng thái"}
                searchable
                clearable
                data={dataStatusOption}
                leftSection={<IconStatusChange color="#15aabf" />}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                key={form.key("status")}
                nothingFoundMessage={"Loading..."}
                {...form.getInputProps("Status")}
              />
            </GridCol>

            <GridCol span={sizeGrid}>
              <Select
                key={
                  dataInventoryTransactionType.length ||
                  form.key("SourceTypeCode")
                }
                placeholder={"Loại chứng từ gốc"}
                searchable
                clearable
                leftSection={<IconFileTypography color="#15aabf" />}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                data={dataInventoryTransactionType}
                nothingFoundMessage={"Loading..."}
                // onClick={() => {
                //   if (dataInventoryTransactionType.length === 0) {
                //     fetchdataInventoryTransactionType();
                //   }
                // }}
                {...form.getInputProps("SourceTypeCode")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <Select
                key={form.key("BranchId")}
                placeholder="Nhập mã hoặc tên chi nhánh"
                data={dataBranch}
                searchable
                clearable
                leftSection={<IconBrandBootstrap color="#15aabf" />}
                nothingFoundMessage="Không tìm thấy dữ liệu !"
                {...form.getInputProps("BranchId")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <Select
                searchable
                clearable
                placeholder="Chọn kho xuất"
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                leftSection={<IconBrandBootstrap color="#15aabf" />}
                nothingFoundMessage={"Loading..."}
                data={dataInv}
                key={dataInv.length || form.key("InvId")}
                // onClick={() => {
                //   if (dataInv.length === 0) {
                //     fetchDataInv();
                //   }
                // }}
                {...form.getInputProps("InvId")}
              />
            </GridCol>
            <GridCol span={sizeGrid}>
              <Select
                placeholder={"Chọn nhân viên"}
                searchable
                clearable
                data={dataEmployee}
                leftSection={<IconUserCode color="#15aabf" />}
                comboboxProps={{
                  transitionProps: { transition: "pop", duration: 200 },
                }}
                nothingFoundMessage={"Loading..."}
                key={dataEmployee.length || form.key("EmpId")}
                // onClick={() => {
                //   if (dataEmployee.length === 0) {
                //     fetchDataEmployee();
                //   }
                // }}
                {...form.getInputProps("EmpId")}
              />
            </GridCol>
            <Grid.Col span={sizeGrid}>
              <Select
                key={form.key("IsEcommerce")}
                placeholder="Loại đơn hàng"
                leftSection={<IconClipboardList color="#15aabf" />}
                data={[{ label: "Đơn hàng TMĐT", value: "true" }]}
                clearable
                {...form.getInputProps("IsEcommerce")}
              />
            </Grid.Col>
            <Grid.Col span={sizeGrid}>
              <Select
                size="sm"
                placeholder="Nhập mã sản phẩm"
                clearable
                searchable
                data={dataItemCodeSelect}
                value={selectedItemCode?.value ?? null}
                onChange={(v, option) => {
                  setSelectedItemCode(
                    v ? (option ?? { value: v, label: v }) : null,
                  );
                  form.setFieldValue("ItemCode", v ?? "");
                }}
                onSearchChange={(value) => {
                  debouncedDataItemCode(value); // Sử dụng debounce
                }}
                leftSection={<IconBarcode size={20} color="#15aabf" />}
              />
            </Grid.Col>
            <GridCol span={{ base: 4, sm: 4, md: 1.5, lg: 1 }}>
              <Button
                leftSection={<IconSearch size={14} />}
                color="blue"
                loading={isLoading}
                variant="outline"
                onClick={async () => {
                  await fetchData();
                  // localStorage.setItem(
                  //   "allValueKeySearch",
                  //   JSON.stringify({
                  //     ...form.getValues(),
                  //     url: String(window.location.pathname),
                  //   })
                  // );
                }}
              >
                Tìm kiếm
              </Button>
            </GridCol>
          </Grid>
        </form>
      </div>

      <div className="mt-5" style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default WarehouseOutWard;
